import React, { forwardRef } from "react";

const phoneNumberInput = Component => {
  // eslint-disable-next-line react/display-name
  return forwardRef((props, ref) => {
    return <Component {...props} inputRef={ref} fullWidth />;
  });
};

export default phoneNumberInput;
